import { PKG } from '../../analytics/analyticsConsts';
import { setLockupImage } from '../../app/merchantDataSlice';
import { AppDispatch, store } from '../../app/store';
import { ANALYTICS } from '../../firebase/firebase';
import { requestAssests } from '../../utils/http';
import { getBaseUrl } from '../http/getRequestMetadata';
import { RequestType } from '../http/httpConsts';

export const getLockupImage = (productUUID: string) => {
  return async (dispatch: AppDispatch) => {
    try {
      const data = (await requestAssests({
        url: `/content/${productUUID}/web-assets/logoLockup.svg`,
        image: true,
      })) as string;
      dispatch(setLockupImage(data));
    } catch (error) {
      ANALYTICS.funcError(PKG, 'getLockupImage', JSON.stringify(error));
    }
  };
};

// Used for mobile SDK. iOS can't handle svg without 3rd-party libs, need to use png.
export const getLockupPngUrl = (productUUID: string) => {
  if (!productUUID) {
    return '';
  }
  return `${getBaseUrl(
    store,
    RequestType.EXTERNAL
  )}/content/${productUUID}/web-assets/logoLockup.png`;
};
